export default __webpack_public_path__ + "static/media/KamilaCamillo_03.44670009.jpg";